export default __webpack_public_path__ + "static/media/get_github_info.bea69aab.webp";